import { createRoot } from 'react-dom/client';
import { useEffect, useState, useRef } from '@wordpress/element';
import { dispatch } from '@wordpress/data';

const { cartStore } = window?.wc?.wcBlocksData || {};
//console.log(window.mafwcCommon);
window.mafwcCheckoutBlock = {

    applyAddress: function(data, addressType) {

        if (!cartStore || !window.wp?.data?.dispatch) {
            return;
        }
        const cartActions = dispatch(cartStore);
        const address = {
            first_name: data.first_name || '',
            last_name: data.last_name || '',
            company: data.company || '',
            address_1: data.address_1 || '',
            address_2: data.address_2 || '',
            city: data.city || '',
            state: data.state || '',
            postcode: data.postcode || '',
            country: data.country || '',
            phone: data.phone || ''
        };

        if (addressType === 'billing') {

            cartActions.setBillingAddress(address);
            const billingEditLink = document.querySelector('.wc-block-checkout__billing-address button, [aria-controls="billing"], [data-block-name="woocommerce/checkout-billing-address-block"] button');
            if (billingEditLink) billingEditLink.click();

        } else if (addressType === 'shipping') {

            cartActions.setShippingAddress(address);
            const checkbox = document.querySelector('.wc-block-checkout__use-address-for-billing input[type="checkbox"]');
            if (checkbox && checkbox.checked) {
                cartActions.setBillingAddress(address);
                const billingEditLink = document.querySelector('.wc-block-checkout__billing-address button, [aria-controls="billing"], [data-block-name="woocommerce/checkout-billing-address-block"] button');
                if (billingEditLink) billingEditLink.click();
            }
            const shippingEditLink = document.querySelector('.wc-block-checkout__shipping-address button, [aria-controls="shipping"], [data-block-name="woocommerce/checkout-shipping-address-block"] button');
            if (shippingEditLink) shippingEditLink.click();
        }
        if (window.jQuery) {
            window.jQuery(document.body).trigger('wc_fragment_refresh');
        }
    },

    addAddressGrid: function(targetSelector, type, insertType = 'after') {

        document.querySelectorAll(`.mafwc-addresses-list.additional-${type}-addresses`).forEach(el => el.remove());
        document.querySelectorAll(`.mafwc-address-link[data-address-type="${type}"]`).forEach(el => el.remove());
        const html = window.mafwcCommon.buildGridHtml(type);
        let target = document.querySelector(targetSelector);
        console.log('target',target);
        console.log('targetSelector',targetSelector);

        //<p class="wc-block-components-checkout-step__description">Enter the billing address that matches your payment method.</p>
        
        if (!target) {
            return;
        }
        let insertMethod;
        switch (insertType.toLowerCase()) {
            case 'append':
                insertMethod = 'append';
                break;
            case 'prepend':
                insertMethod = 'prepend';
                break;
            case 'after':
                insertMethod = 'after';
                break;
            case 'before':
                insertMethod = 'before';
                break;
            default:
                insertMethod = 'after';
                break;
        }
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const elements = Array.from(temp.children);
        if (insertMethod === 'append') {
            elements.forEach(el => target.append(el));
        } else if (insertMethod === 'prepend') {
            elements.forEach(el => target.prepend(el));
        } else if (insertMethod === 'after') {
            elements.forEach(el => target.after(el));
        } else if (insertMethod === 'before') {
            elements.forEach(el => target.before(el));
        }
        const grid = document.querySelector(`.mafwc-addresses-list.additional-${type}-addresses`);
        if (grid && mafwcSettings.add_new_links[type]) {
            const temp2 = document.createElement('div');
            temp2.innerHTML = mafwcSettings.add_new_links[type];
            const linkElements = Array.from(temp2.children);
            linkElements.forEach(el => grid.after(el));
        }
        document.querySelectorAll(`.mafwc-addresses-list.additional-${type}-addresses .mafwc-use-this`).forEach(el => {
            el.style.display = 'inline-block';
        });
    }
};

function MafwcCheckoutBlock() {
    
    const [addressesLoaded, setAddressesLoaded] = useState(false);
    const checkboxListenerRef = useRef(null);
    
    const applyDefaultIfSet = (addressType) => {
        
        const isDefaultKey = `is_default_${addressType}`;
        const defaultAddrKey = `default_${addressType}_address`;
        if (mafwcSettings[isDefaultKey] && mafwcSettings[defaultAddrKey]) {
            window.mafwcCheckoutBlock.applyAddress(mafwcSettings[defaultAddrKey], addressType);
        }
    };

    const initGridsAndLoad = () => {

        const billingSelector = 'fieldset.wc-block-checkout__billing-fields .wc-block-components-checkout-step__container .wc-block-components-checkout-step__description';
        const shippingSelector = 'fieldset.wc-block-checkout__shipping-fields .wc-block-components-checkout-step__container .wc-block-components-checkout-step__description';

        if (document.querySelector('.wc-block-checkout')) {

            window.mafwcCheckoutBlock.addAddressGrid(billingSelector, 'billing');
            window.mafwcCheckoutBlock.addAddressGrid(shippingSelector, 'shipping');
            setAddressesLoaded(true);

        } else {

            const observer = new MutationObserver((mutations, obs) => {
                if (document.querySelector('.wc-block-checkout')) {

                    window.mafwcCheckoutBlock.addAddressGrid(billingSelector, 'billing');
                    window.mafwcCheckoutBlock.addAddressGrid(shippingSelector, 'shipping');
                    obs.disconnect();
                    setAddressesLoaded(true);
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
            return () => observer.disconnect();  // Cleanup for observer
        }
    };

    useEffect(() => {

        const waitForMafwc = () => {
            if (window.mafwcCommon) {
                const cleanup = initGridsAndLoad();
                return cleanup;
            } else {
                setTimeout(waitForMafwc, 100);
            }
        };
        const cleanup = waitForMafwc();
        return cleanup;

    }, []);

    useEffect(() => {

        if (!addressesLoaded) return;
        
        if(mafwcSettings.applyDefaultAddress == '1' || mafwcSettings.applyDefaultAddress == 'yes' ){
            applyDefaultIfSet('billing');
            applyDefaultIfSet('shipping');
        }
        

    }, [addressesLoaded]);
    
    // NEW: useEffect to uncheck "same address" checkbox on load to show billing fields/grids

    /*
    useEffect(() => {
    if (!addressesLoaded) return;

    // Simply ensure billing grid is added regardless of checkbox state
    const billingSelector = 'fieldset.wc-block-checkout__billing-fields .wc-block-components-checkout-step__container .wc-block-components-checkout-step__description';
    window.mafwcCheckoutBlock.addAddressGrid(billingSelector, 'billing');
    
    // Also uncheck the checkbox via DOM as fallback
    const checkbox = document.querySelector('.wc-block-checkout__use-address-for-billing input[type="checkbox"]');
    if (checkbox && checkbox.checked) {
        checkbox.checked = false;
    }
}, [addressesLoaded]); */

    /*
    useEffect(() => {
        if (!addressesLoaded) return;

        const checkbox = document.querySelector('.wc-block-checkout__use-address-for-billing input[type="checkbox"]');
        if (checkbox && checkbox.checked) {  // Only if initially checked; adjust to always uncheck if preferred
            checkbox.checked = false;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));  // Trigger WC React state change
            console.log('[MAFWC] Auto-unchecked billing checkbox to show saved addresses');
        }
    }, [addressesLoaded]);*/

    // NEW: useEffect to attach checkbox change listener after grids are loaded
    useEffect(() => {
        if (!addressesLoaded) return;

        const billingSelector = 'fieldset.wc-block-checkout__billing-fields .wc-block-components-checkout-step__container .wc-block-components-checkout-step__description';
        let checkbox = document.querySelector('.wc-block-checkout__use-address-for-billing input[type="checkbox"]');

        if (!checkbox) {
            console.warn('[MAFWC] Checkbox not found; retrying in 500ms...');
            const retry = setTimeout(() => {
                // Re-run this effect logic once more
                if (checkboxListenerRef.current) {
                    checkboxListenerRef.current();
                }
                const retryCheckbox = document.querySelector('.wc-block-checkout__use-address-for-billing input[type="checkbox"]');
                if (retryCheckbox) {
                    const handleChange = (e) => {
                        if (!e.target.checked) {
                            // Re-append billing grid when unchecked (fields become visible)
                            window.mafwcCheckoutBlock.addAddressGrid(billingSelector, 'billing');
                        }
                    };
                    retryCheckbox.addEventListener('change', handleChange);
                    checkboxListenerRef.current = () => retryCheckbox.removeEventListener('change', handleChange);
                }
            }, 500);
            return () => clearTimeout(retry);
        }

        const handleChange = (e) => {
            if (!e.target.checked) {
                // Re-append billing grid when unchecked (fields become visible)
                window.mafwcCheckoutBlock.addAddressGrid(billingSelector, 'billing');
            }
        };

        checkbox.addEventListener('change', handleChange);
        checkboxListenerRef.current = () => checkbox.removeEventListener('change', handleChange);

        // Cleanup on unmount
        return () => {
            if (checkboxListenerRef.current) {
                checkboxListenerRef.current();
            }
        };
    }, [addressesLoaded]);  // Depend on addressesLoaded to ensure grids/block are ready

    return null;
}

const containerId = 'mafwc-checkout-block-container';
let container = document.getElementById(containerId);

if (!container) {
    container = document.createElement('div');
    container.id = containerId;
    (document.querySelector('.wc-block-checkout') || document.body).appendChild(container);
}
if (!container.dataset.mounted) {
    const root = createRoot(container);
    root.render(<MafwcCheckoutBlock />);
    container.dataset.mounted = 'true';
}